<template>
    <div>
        {{message}}
        <FileUpload name="demo[]"
                    :customUpload="true"
                    @uploader="onUpload"
                    :auto="true"
                    :maxFileSize="1000000">
            <template #empty>
                <p>Drag and drop files to here to upload.</p>
            </template>
        </FileUpload>
    </div>
</template>

<script>
    import UploadService from "../services/upload-files.service";

    export default {
        name: "FileUploader",
        data() {
            return {
                selectedFiles: [],
                currentFile: undefined,
                progress: 0,
                message: "",
                fileInfos: []
            };
        },
        methods: {
            onUpload(event) {
                console.log(event.files[0]);
                // this.$toast.add({severity: 'info', summary: 'Success', detail: 'File Uploaded', life: 3000});
                this.currentFile = event.files[0];
                UploadService.uploadUserList(this.currentFile, event => {
                    this.progress = Math.round((100 * event.loaded) / event.total);
                })
                    .then(response => {
                        this.message = response.data.message;
                    })
                    .catch(() => {
                        this.progress = 0;
                        this.message = "Could not upload the file!";
                        this.currentFile = undefined;
                    });

                this.selectedFiles = undefined;
            }
        },
        selectFile() {
            this.selectedFiles = this.$refs.file.files;
        }
    }
</script>

<style scoped>

</style>